module.exports = "pegasus/assets/classic-facebook.png";